import {
  Box,
  SimpleGrid,
  useColorModeValue,
  useBreakpointValue,
  Flex,
  Heading,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import LoadingComponent from "components/Main/Loading";
import { BarSupplier } from "components/PurchaseSupplier/Bar";

// Custom components

// Assets
import TableGrid from "components/Table";
import PurchaseSupplierGridMobile from "components/Table/Responsive/PurchaseSupplier";
import { parsePurchaseSupplier } from "helpers/Grid/PurchaseSupplierParse";
import usePurchaseSupplier from "hooks/Supplier/use-purchase";
import { ITableHeader } from "Interfaces/Components/TableGrid";
import { useEffect, useState } from "react";
import { useImmer } from "use-immer";
import PurchaseSupplierHeader from "variables/Header/PurschaseSupplier";

export default function PurchaseSupplier() {
  const { data, getData, isFirstData, loading, supplierSelect } =
    usePurchaseSupplier();
  const bgLoading = useColorModeValue("white", "#111C44");
  const [headers1] = useImmer<ITableHeader[]>(PurchaseSupplierHeader);
  const isMobile = useBreakpointValue({ base: true, md: false });

  // useEffect(() => {
  //   isFirstData && getData();
  // });

  const [filteredItems, setFilteredItems] = useState<any[]>(data);

  const handleSearch = (term: string) => {
    const filteredItems = data.filter((item) =>
      Object.values(item).some((value) =>
        value.toString().toLowerCase().includes(term.toLowerCase())
      )
    );
    setFilteredItems(filteredItems);
  };
  useEffect(() => {
    setFilteredItems(data);
  }, [data]);

  return (
    <>
      <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        <SimpleGrid
          mb="10px"
          columns={{ sm: 1, md: 1 }}
          spacing={{ base: "20px", xl: "20px" }}
        >
          <Card
            flexDirection="column"
            w="100%"
            px="0px"
            overflowX={{ sm: "scroll", lg: "hidden" }}
          >
            <BarSupplier onSearch={handleSearch} />
            <Box pt={6}>
              {loading ? (
                <>
                  <Box bg={bgLoading}>
                    <LoadingComponent spinnerSize="50vh" />
                  </Box>
                </>
              ) : (
                <>
                  {isMobile ? (
                    <>
                      {data.length === 0 ? (
                        <>
                          <Box bg={bgLoading} borderRadius="2%">
                            <Flex
                              flexDir="column"
                              alignItems="center"
                              justifyContent="center"
                              bg="white.600"
                              borderRadius="8px"
                              h="calc(70vh - 8px)"
                              p={6}
                            >
                              <Heading
                                mb={5}
                                textAlign="center"
                                fontSize={["20px", "20px", "30px"]}
                                fontWeight="800"
                                color="green.600"
                              >
                                {supplierSelect?.value === 0
                                  ? " Nenhum fornecedor selecionado"
                                  : "Nenhum dado encontrado"}
                              </Heading>
                            </Flex>
                          </Box>
                        </>
                      ) : (
                        <>
                          <PurchaseSupplierGridMobile
                            header={headers1}
                            data={filteredItems}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {data.length === 0 ? (
                        <>
                          <Box bg={bgLoading} borderRadius="2%">
                            <Flex
                              flexDir="column"
                              alignItems="center"
                              justifyContent="center"
                              bg="white.600"
                              borderRadius="8px"
                              h="calc(70vh - 8px)"
                              p={6}
                            >
                              <Heading
                                mb={5}
                                textAlign="center"
                                fontSize={["20px", "20px", "30px"]}
                                fontWeight="800"
                                color="green.600"
                              >
                                {supplierSelect?.value === 0
                                  ? " Nenhum fornecedor selecionado"
                                  : "Nenhum dado encontrado"}
                              </Heading>
                            </Flex>
                          </Box>
                        </>
                      ) : (
                        <>
                          <TableGrid
                            id="schedule-drawer"
                            headers={headers1}
                            data={parsePurchaseSupplier(filteredItems)}
                            itsSortable={true}
                            entity="purchase-supplier"
                            height={"420px"}
                          />
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </Box>
          </Card>
        </SimpleGrid>
      </Box>
    </>
  );
}
